import adverts from '../modules/adverts';

adverts.startLytics();
adverts.init();
